import React from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import {Button} from '../../../../common/components/';
import { LOCATION_ORIGIN } from '../../../../common/call-api';
import ButtonLink from '../../../../common/components/ButtonLink';
import HR from '../HorizontalRule';
import Redirect from '../../../../common/components/Redirect';
import {
  TitleBar,
  DocTitle,
} from '../../../../common/components/Layout/StandardPageTemplate/Context';
import { withLoading } from '../../../../redux-modules/loading-overlay';
import { getCurrentUser } from '../../../../redux-modules/current-user';
import {
  SortProperty,
  genericObjectSort,
} from '../../../../common/utils/object-sort';
import ActivitiesActions from '../../actions/activities';
import { getActivities } from '../../selectors/activities';
import ActionHandler from '../ActionHandler';
import ActivityList from './ActivityList';
import LoadingView from '../../../../common/components/LoadingView';
import styles from './ActivitiesPage.css';
import { getStateNameFromStateCode } from '../../../events/utils';

// TODO: handle expanding and closing of past events
class ActivitiesPage extends React.Component {
  static propTypes = {
    activities: PropTypes.arrayOf(PropTypes.object),
    isLoading: PropTypes.bool,
    currentUser: PropTypes.shape({
      id: PropTypes.string,
    }),
    actions: PropTypes.shape({
      activities: PropTypes.objectOf(PropTypes.func),
    }),
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_GET',
        meta: { namespace: 'activities' },
      },
    ],
  };
  state = {
    goToEvent: {
      redirect: false,
      key: '',
    },
    isFetchingActivities: !this.props.activities || !this.props.activities.length,
  };

  fetchActivities = (...args) => {
    this.setState({ isFetchingActivities: true });
    return this.props.actions.activities
      .get(...args)
      .then(result => {
        this.setState({ isFetchingActivities: false });
        return result;
      })
      .catch(error => {
        this.setState({ isFetchingActivities: false });
        throw error;
      });
  };

  handleGoToEvent = eventKey => () => {
    return this.setState(prevState => ({
      ...prevState,
      goToEvent: {
        redirect: true,
        key: eventKey,
      },
    }));
  };

  convertEventToTile = activity => {
    const { eventDateSummary, eventName, locationSummary, eventKey } = activity;
    const eventState = locationSummary
      .slice(locationSummary.indexOf(',') + 1, locationSummary.length)
      .trim();
    return {
      id: eventKey,
      icon: () => <span className={styles.bubble}>{getStateNameFromStateCode(eventState)}</span>,
      details: {
        date: {
          value: eventDateSummary,
          className: styles.eventDate,
        },
        name: {
          value: eventName,
          className: styles.eventName,
        },
        location: {
          value: locationSummary,
          className: styles.locationSummary,
        },
      },
      action: {
        label: 'view',
        icon: 'chevron_right',
        clickHandler: this.handleGoToEvent(eventKey),
      },
    };
  };

  render() {
    // check for redirect
    const { goToEvent } = this.state;
    if (goToEvent.redirect) {
      return (
        <Redirect
          external
          to={`${LOCATION_ORIGIN}/events/${goToEvent.key}/confirmation?cst=${this
            .props.currentUser.id}`}
        />
      );
    }

    // split up and sort events
    const activities = this.props.activities || [];
    const sortPast = [new SortProperty('eventDate', false)];
    const past = activities
      .filter(
        activity =>
          activity.eventDate.isBefore(moment()) ||
          activity.eventDate.isSame(moment())
      )
      .sort(genericObjectSort(sortPast))
      .map(this.convertEventToTile);
    const upcoming = activities
      .filter(activity => activity.eventDate.isAfter(moment()))
      .map(this.convertEventToTile);

    const noEventsMessage =
      'We have no events coming up that you have registered to attend. ' +
      'If you feel this is an error, please contact Member Services at 1-800-NFIB-NOW. ' +
      'To Register for an upcoming event online, please visit the link below to find a ' +
      'catalog of planned NFIB Events in your area.';

    // TODO: get color and title values from config
    const pageTitle = 'My Events';

    return (
      <div>
        <TitleBar title={pageTitle} />
        <DocTitle title={pageTitle} />
        <ActionHandler
          condition={!this.props.activities || !this.props.activities.length}
          action={this.fetchActivities}
        />
        {this.state.isFetchingActivities ? (
          <LoadingView />
        ) : (
          <div>
            <ActivityList
              title="registered events"
              activities={upcoming}
              color="teal"
              noDataMessage={noEventsMessage}
            />
            <Button
              className={styles.button}
              label="View all upcoming events"
              to={'/events'}
            />
            <HR color="teal" />

            <ActivityList title="past events" activities={past} color="teal" />
            <HR color="teal" />
          </div>
        )}

        <ButtonLink
          primary
          raised
          to="/account"
          className={styles.buttonLink}
          label="Back to Account Management"
          style={{ marginTop: 0 }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const activities = getActivities(state).map(activity => {
    return {
      ...activity,
      eventDate: moment(activity.eventDateSummary, 'M/D/YYYY'),
    };
  });
  return {
    activities: activities.sort(
      genericObjectSort([new SortProperty('eventDate')])
    ),
    currentUser: getCurrentUser(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      activities: bindActionCreators(ActivitiesActions, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withLoading(ActivitiesPage)
);



// WEBPACK FOOTER //
// ./src/App/account/components/ActivitiesPage/index.js